module.exports = __webpack_public_path__ + "img/c_qfpay_pc.b3e71ef4.svg";